import { useFormAction, useNavigation } from '@remix-run/react';

/**
 * Similar to Remix's `useNavigation().state` but scoped to the current route
 * (ie. this one ignores other routes' states, and also ignores navigating away
 * from the current page)
 *
 * Useful for displaying loading indicators for both submission and fetching additional
 * content within the same route
 *
 * Also check out `useRouteNavigation()` if you need more than just the `.state`
 */
export function useRouteNavigationState() {
  const navigation = useNavigation();
  const formAction = useFormAction();

  const current = formAction?.split('?')[0];

  return navigation.formAction?.startsWith(current) ||
    navigation.location?.pathname?.startsWith(current)
    ? navigation.state
    : 'idle';
}
